export default __webpack_public_path__ + "static/media/kryptos.48b0cd9f.png";